// 资源分析公共组件
import drawUtils from './DrawUtils';
const componentBase = (G as any).base.ComponentBase;
const NearbySearch = componentBase.extend({
    // 属性
    options: {
        map: null,
        config: null,
        PanoComp: null,
        MeatureComp: null,
        highLightId: 'search_highlight', // 高亮id
        tempHighLightId: 'temp_highlight', // 提示框id
    },

    // 初始化
    initialize(options: any) {
        componentBase.prototype.initialize.call(this, options);
        this.map = G.g2map;
    },

    // 加载
    load() {
        componentBase.prototype.load.call(this);
        this.initSimpleRenderMgr();
    },

    // 初始化渲染工具
    initSimpleRenderMgr() {
        this.simpleRenderMgr = new (G as any).render.SimpleRenderMgr({
            map: this.map,
        });
        this.simpleRenderMgr.load();
        // 绘图工具初始化
        this.drawUtil = new drawUtils({
            map: this.map,
        });
        this.drawUtil.load();
    },

    // 绘制点
    DrawPoint(distance: number = 50, callback: any) {
        this.drawUtil.DrawPoint(distance * 1000, (res: any) => {
            if (callback) {
                callback(res);
            }
        });
    },
    // 根据事件点生成缓冲区
    pointBuffer(distance: number = 50, element: any, callback: any) {
        this.drawUtil.pointBuffer(element, distance * 1000, (res: any) => {
            if (callback) {
                callback(res);
            }
        });
    },
    // 绘制线
    DrawPolyline(distance: number = 50, callback: any) {
        this.drawUtil.DrawPolyline(distance * 1000, (res: any) => {
            if (callback) {
                callback(res);
            }
        });
    },
    // 绘制面
    DrawPolygon(distance: number = 50, callback: any) {
        this.drawUtil.DrawPolygon(distance * 1000, (res: any) => {
            if (callback) {
                callback(res);
            }
        });
    },
    // 清除数据
    clearResourceLayer() {
        this.simpleRenderMgr.removeAll();
        this.drawUtil.ClearDrawLayer();
    },
    // 销毁组件
    destroySimpleRenderMgr() {
        this.clearResourceLayer();
        this.simpleRenderMgr.destroy();
    },
    // 销毁
    destroy() {
        this.destroySimpleRenderMgr();
        this.drawUtil.destroy();
        componentBase.prototype.destroy.call(this);
    },
    // 卸载
    unload() {
        componentBase.prototype.unload.call(this);
    },
});

export default NearbySearch;
